//@flow
import React from 'react';

type Props = {
  bsSize: string,
  bsStyle: string,
  disabled: boolean,
  onClick?: Function,
  children: *,
  className?: string | Array<string>,
  style?: Object,
  href?: string
}
class Button extends React.Component<Props> {
  static defaultProps = {
    bsSize: "small",
    bsStyle: "default",
    disabled: false
  }
  handleLink() {
    //TODO add linking via href
  }
  render() {
    const size = (this.props.bsSize === 'small') || (this.props.bsSize === 'sm') ? "btn-sm" : "";
    const cna = this.props.className && Array.isArray(this.props.className) ? this.props.className.join(" ") : "";
    const cns = this.props.className && typeof this.props.className === 'string' ? this.props.className : "";

    let style = {
      position: 'relative',
      // top: '-2px'
    };
    Object.assign(style, this.props.style);

    let button = null;
    if (this.props.onClick) {
      button = <button
        style={style}
        type="button"
        className={`btn ${size} btn-${this.props.bsStyle} ${cna} ${cns}`}
        onClick={this.props.onClick ? this.props.onClick : () => this.handleLink()}
        disabled={this.props.disabled}>
        {this.props.children}
      </button>;
    } else
      if (this.props.href) {
        button = <button
          style={style}
          type="button"
          className={`btn ${size} btn-${this.props.bsStyle} ${cna} ${cns}`}
          onClick={() => window.location.href = this.props.href}
          disabled={this.props.disabled}>
          {this.props.children}
        </button>;
      } else {
        button = <button
          style={style}
          type="button"
          disabled={true}>
          dead button
  </button>
      }

    return button;
  }
}
export default Button;